export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5903.60ed1397.jpg";